module.exports = "./dist/stdassets/images/icons/pan-east.png";